<div class="compact-stats">
    <div class="title-tabs-row">
        <div class="title-group">
            <span class="title">Snittverdier</span>
            <span class="subtitle"> per ...</span>
        </div>
        <div class="tabs">
            <button class="tab" [class.active]="mode() === 'total'" (click)="setMode('total')">Total</button>
            <button class="tab" [class.active]="mode() === 'soldUnsold'" (click)="setMode('soldUnsold')">Solgt/usolgt</button>
        </div>
    </div>

    <div class="stats-table">
        <div class="header-row">
            <div class="col-key"></div>
            @if (mode() === 'total') {
                <div class="col-val">TOTAL</div>
            } @else {
                <div class="col-val">SOLGT</div>
                <div class="col-val">USOLGT</div>
            }
        </div>

        @for (row of rows(); track row.label; let last = $last) {
            <div class="key-value" [class.last]="last">
                <div class="key">{{ row.label }}</div>
                @if (mode() === 'total') {
                    <div class="value">{{ row.total | number:'1.0-0' | dash }}{{ row.total ? row.suffix : '' }}</div>
                } @else {
                    <div class="value">{{ row.sold | number:'1.0-0' | dash }}{{ row.sold ? row.suffix : '' }}</div>
                    <div class="value">{{ row.unsold | number:'1.0-0' | dash }}{{ row.unsold ? row.suffix : '' }}</div>
                }
            </div>
        }
    </div>
</div>
